<script context="module">
  import Viewport from "svelte-viewport-info";
</script>

<script>
  import { Swiper, SwiperSlide } from "swiper/svelte";
  import { SpinLine } from "svelte-loading-spinners";
  import Player from "./Player.svelte";
  import Desktop from "./Desktop.svelte";

  // Import Swiper styles
  import "swiper/css";
  let portrait = Viewport.Width < Viewport.Height;

  import "./style.css";

  let isPlay = false;
  let player;
  let playerInit = false;

  let needDownArrow = true;

  let firstVideoId;
  let currentSlideIndex;

  let isDesktop;

  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    isDesktop = false;
  } else {
    isDesktop = true;
  }

  async function initPlayer(videoid) {
    return new Promise((resolve, reject) => {
      player = new YT.Player("player", {
        events: {
          onReady: (event) => {
            if (videoid) player.loadVideoById(videoid);
            onPlayerReady(event);
            playerInit = true;
            resolve();
          },
          onStateChange: onPlayerStateChange,
        },
        playerVars: {
          autoplay: 0,
          controls: 0,
          showinfo: 0,
          rel: 0,
          playsinline: 0,
          modestbranding: 1,
          origin: location.origin,
        },
      });
    });
  }

  async function getPlaylist() {
    let response = await fetch(
      "https://youtube.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=50&playlistId=PLX99umi-nuqzZIV6PjrXY_b3Lv08xr6yL&key=AIzaSyBhizMCKkMLHdrYZq8kYvCEbLQDD4MobxA"
    );
    let playlist = await response.json();
    firstVideoId = playlist.items[0].snippet.resourceId.videoId;
    
    return playlist.items.filter(item => item.snippet.title != "Deleted video");
  }
  async function play(videoid) {
    isPlay = true;
    if (!playerInit) {
      await initPlayer(videoid);
    } else {
      player.loadVideoById(videoid);
    }
  }

  function onPlayerReady(event) {
    event.target.playVideo();
  }

  function onPlayerStateChange(event) {}

  function closePlayer() {
    isPlay = false;
    if (player) {
      try {
        player.stopVideo();
      } catch (err) {}
    }
  }

  function slidechange(ev) {
    currentSlideIndex = ev.detail[0][0].activeIndex;
  }

  function sliderFirstMove() {
    needDownArrow = false;
  }

  function getThumb(thumbs) {

    if (thumbs.maxres) {
      return thumbs.maxres.url;
    }
    if (thumbs.high) {
      return thumbs.high.url;
    }
    if (thumbs.medium) {
      return thumbs.medium.url;
    }

  }

  var tag = document.createElement("script");

  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
</script>

<svelte:body
  on:viewportchanged={() => {
    portrait = Viewport.Width < Viewport.Height;
  }}
  on:orientationchangeend={() => {
    portrait = Viewport.Width < Viewport.Height;
  }} />
{#await getPlaylist()}
  <div class="loader">
    <SpinLine size="120" color="red" unit="px" duration="4s" />
  </div>
{:then items}
  <div class="video-player">
    <div style={!isPlay ? "display:none" : ""} class="player-container">
      <a
        href="https://www.youtube.com/channel/UCVEf5qvBUZBAuGkBeQGJhSg?sub_confirmation=1"
        class="button-31">ПОДПИСАТЬСЯ</a
      >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        on:click={closePlayer}
        class="closebutton"
        fill="none"
        viewBox="0 0 24 24"
        stroke="#EEEEEE"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
      <iframe
        id="player"
        loading="lazy"
        width="560"
        height="315"
        src="https://www.youtube.com/embed/{firstVideoId}?&color=white&controls={isDesktop
          ? 1
          : 0}&modestbranding=1&playsinline=0&rel=0&enablejsapi=1&origin={location.origin}"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      />
    </div>
  </div>
  {#if !isPlay}
    {#if !isDesktop}
      <Swiper
        initialSlide={currentSlideIndex || "0"}
        on:slideChange={(ev) => slidechange(ev)}
        on:sliderFirstMove={sliderFirstMove}
        slidesPerView={portrait ? "2" : "1"}
        direction={"vertical"}
        mousewheelControl={true}
        class="mySwiper"
      >
        {#each items as item (item.snippet.position)}
          <SwiperSlide>
            <Player
              play={(event) => play(event)}
              videoid={item.snippet.resourceId.videoId}
              image={getThumb(item.snippet.thumbnails)}
              title={item.snippet.title}
            />
          </SwiperSlide>
        {/each}
        {#if needDownArrow}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="downArrows"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 13l-7 7-7-7m14-8l-7 7-7-7"
            />
          </svg>
        {/if}
      </Swiper>
    {:else}
      <Desktop play={(event) => play(event)} {items} />
    {/if}
  {/if}
{:catch err}
  <h1 class="error">
    Произошла ошибка, не удалось загрузить данные. Пожалуйста, попробуйте зайти
    позже.
  </h1>
{/await}

<style>
  .error {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .video-player {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .player-container {
    position: relative;
    max-width: 100%;
    height: 100%;
  }

  .closebutton {
    background-color: black;
    position: relative;
    float: right;
    width: 60px;
    height: 60px;
    border-radius: 100%;
  }
  .closebutton:active {
    stroke: yellowgreen;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    outline: 0;
  }

  .loader {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .downArrows {
    stroke: white;
    position: absolute;
    bottom: 0px;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;

    width: 90px;
    height: 90px;
    animation: downarrow 0.6s infinite alternate ease-in-out;
  }

  .button-31 {
    background-color: rgb(204, 0, 0);
    border-radius: 2px;
    border-style: none;
    box-sizing: border-box;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    font-family: Roboto, Arial, sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 1.5;
    margin: 12px;
    height: 36px;
    outline: none;
    overflow: hidden;
    padding-bottom: 10px;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 8px;
    position: relative;
    text-align: center;
    text-transform: none;
    text-decoration: none;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    letter-spacing: 0.5px;
  }

  .button-31:hover,
  .button-31:focus {
    opacity: 0.75;
    text-decoration: none;
  }

  

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes downarrow {
    0% {
      -webkit-transform: translateY(0);
      opacity: 0.2;
    }
    100% {
      -webkit-transform: translateY(0.4em);
      opacity: 0.5;
    }
  }
</style>
